import { createSlice } from '@reduxjs/toolkit';

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState: {
    favorites: [],
    status: 'idle',
    error: null
  },
  reducers: {
    addToFavorites: (state, action) => {
      const product = action.payload;
      const existingIndex = state.favorites.findIndex(item => item.id === product.id);
      
      if (existingIndex === -1) {
        state.favorites.push({
          ...product,
          favoritedAt: new Date().toISOString()
        });
      }
    },
    removeFromFavorites: (state, action) => {
      const productId = action.payload;
      state.favorites = state.favorites.filter(item => item.id !== productId);
    },
    toggleFavorite: (state, action) => {
      const product = action.payload;
      const existingIndex = state.favorites.findIndex(item => item.id === product.id);
      
      if (existingIndex === -1) {
        // Add to favorites
        state.favorites.push({
          ...product,
          favoritedAt: new Date().toISOString()
        });
      } else {
        // Remove from favorites
        state.favorites.splice(existingIndex, 1);
      }
    },
    clearFavorites: (state) => {
      state.favorites = [];
    }
  }
});

export const { addToFavorites, removeFromFavorites, toggleFavorite, clearFavorites } = favoritesSlice.actions;

export default favoritesSlice.reducer;
